'use client';
import { PostStoryblok, SectionStoryblok } from '@/storyblok/types';
import { titleToElementId } from '@/storyblok/components/post/utils';
import { useMemo } from 'react';
import Link from 'next/link';
import { StoryblokReactComponent } from '@/storyblok/components/componentsMap';

export const PostSummary: StoryblokReactComponent<PostStoryblok> = ({ component }) => {
  const indexes = useMemo(
    () =>
      component.body
        ?.filter((blok): blok is SectionStoryblok => blok.component === 'section')
        .flatMap(blok => blok.body.content ?? [])
        .filter(content => content.type === 'heading' && content.attrs?.level === 2)
        .flatMap(content => content.content ?? [])
        .map(content => content.text)
        .filter((text): text is string => typeof text === 'string' && text.length > 0) ?? [],
    [component.body],
  );

  return (
    <div className="rounded-2xl border border-primary/15 bg-white  p-5 shadow-sm sm:p-7 md:p-8" id="post-summary">
      <div className="mb-4 flex items-baseline justify-between md:mb-5">
        <h2 className="text-sm font-medium uppercase tracking-widest text-neutral-lighter lg:text-base">Indice</h2>
        <span className="text-xs text-neutral-lighter">{indexes.length} sezioni</span>
      </div>

      <ol className="grid grid-cols-1 gap-x-6 gap-y-0.5 sm:grid-cols-2 sm:gap-y-1 md:gap-x-8">
        {indexes.map((title, i) => (
          <li key={i} className="overflow-hidden">
            <Link
              className="border-neutral-surface/50/50 sm:[&amp;:nth-last-child(2)]:border-b-0 group flex items-center gap-3 border-b py-2.5 transition-colors last:border-b-0 sm:gap-4 sm:py-3"
              href={`#${titleToElementId(title)}`}
              title={title}
              onClick={e => {
                e.preventDefault();
                document.getElementById(titleToElementId(title))?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              <span className="flex size-6 shrink-0 items-center justify-center rounded-full bg-primary-active/10 text-xs font-bold text-primary transition-colors group-hover:bg-primary group-hover:text-white sm:size-7">
                {(i + 1).toString().padStart(2, '0')}
              </span>

              <span className="text-sm font-medium text-neutral-darker transition-colors group-hover:text-primary">{title}</span>
            </Link>
          </li>
        ))}
      </ol>
    </div>
  );
};
